import * as fromDatatype from '../datatype-library/index';

export interface bl_inv_txn_sub_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_inv_txn_line: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  reference_key_1: fromDatatype.VarcharDatatypeInterface;
  reference_key_2: fromDatatype.VarcharDatatypeInterface;
  reference_key_3: fromDatatype.VarcharDatatypeInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_inv_txn_sub_line_RowClass
  implements bl_inv_txn_sub_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_inv_txn_line: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  reference_key_1: fromDatatype.VarcharDatatypeInterface;
  reference_key_2: fromDatatype.VarcharDatatypeInterface;
  reference_key_3: fromDatatype.VarcharDatatypeInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
